import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SettingService {

  private EDNPOINT = environment.ENDPOINTS.VARIABLES_GLOBALES;

    constructor(
      private http: HttpClient
    ) { }

    getVariablesGlobales() {
        return this.http.get<any>(this.EDNPOINT);
      }
}
